import {Component, trigger, transition, style, animate, state, Input} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MdInputContainer, MdDatepicker, MdInputDirective } from '@angular/material';

import { NceService } from './../../../nce/services/nce.service';
import { NceAdminService } from './../../../nce-admin/services/nce-admin.service';
import { PopupService } from './../../services/pop-up.service';

@Component({
	selector: 'pop-up-change-appointment',
	templateUrl: 'change-appointment-popup.component.html',
	animations: [
	trigger(
		'popupAnimation',
		[
			transition(
			':enter', [
				style({opacity: 0}),
				animate('300ms', style({'opacity': 1}))
			]
		),
		transition(
			':leave', [
				style({'opacity': 1}),
				animate('300ms', style({'opacity': 0}))
			]
		)]
	)
],
})

export class ChangeAppointmentPopupComponent {

    @Input()
    vAppointmentData = {
        updated_date: new Date(),
        appointment_date: new Date(),
        appointment_time: '',
        appointment_description: '',
        appointment_type: '',
        popup_title: ''
    };

	/*vSelectedDate: Date = new Date(this._nceService.getDetailNCE().appointment_date);
    vSelectedTime: String = this._nceService.getDetailNCE().appointment_time;
    vSelectedTimeDesc: String = this._nceService.getDetailNCE().appointment_description;

    vUpdatedDate: Date = new Date(this._nceService.getAppointmentAvaibility().updated_date);*/

    minDate: Date = new Date();

    counter = 0;
    countTime = 0;

	constructor(
        private _nceService: NceService,
        private _nceAdminService: NceAdminService,
		private _popupService: PopupService
	) {

	}

	getChangeAppointmentFlag() {
		return this._popupService.getChangeAppointmentFlag();
	}

    isNoAvailableTime(){
        this.countTime = 0;
        for(let timeType of this.getListTime()){
            if(!timeType.availability) {
                this.countTime ++;
            }
        }
        return this.countTime === this.getListTime().length;
    }

    getListTime(){
        return this._nceService.getListTime();
    }

    isLoading(){
        return this._nceService.isLoading();
    }

    getAppointmentAvailability(){
        return this._nceService.getAppointmentAvaibility();
    }

    /*myFilter = (d: Date): boolean => {
        const day = d.getDay();
        if(this.getAppointmentAvailability().holiday.some(x => x === (d.getMonth() + 1) + '-' + d.getDate()) || (day == 0 || day == 6)){
            return false;
        }else{
            if(this.counter < this.getAppointmentAvailability().days && d.getTime() >= this.vUpdatedDate.getTime() && 
            (d.getMonth() + '-' +d.getDate() !== this.vUpdatedDate.getMonth() + '-' +this.vUpdatedDate.getDate()) ){
                this.counter++;
                this.minDate = d;
                if(this.counter == this.getAppointmentAvailability().days){
                    return true;
                }
                return false;
            }
            return true;
        }
    }

    resetCounter(){
        if(this.counter < this.getAppointmentAvailability().days){
            this.counter = 0;
        }
    }*/

    resetCounter(){
        let today = new Date();
        this.minDate.setDate(today.getDate() + 1);

        let updated_date = new Date(this.vAppointmentData.updated_date);
        let day = updated_date.getDay();
        
        while(this.counter < this.getAppointmentAvailability().days){
            day = updated_date.getDay();
            if(!(this.getAppointmentAvailability().holiday.some(x => x === (updated_date.getMonth() + 1) + '-' + updated_date.getDate()) || day == 0 || day == 6)){
                this.counter++;
                this.minDate = updated_date;
            }
            updated_date.setDate(updated_date.getDate() + 1);
        }
        let buffer = this.getAppointmentAvailability().buffer ? this.getAppointmentAvailability().buffer : 0;
        if(this.minDate.getTime() < today.getTime()){
            today.setDate(today.getDate()+ 1+ buffer);
            this.minDate = today;
        }
    }

    myFilter = (d: Date): boolean => {
        const day = d.getDay();
        // Rama requested that 1 day after holiday to be blocked
        function calculateNextDate(holidayString : string) {
            let dateNow = new Date();
            dateNow = new Date (dateNow.getFullYear() + '-' + holidayString.split('-')[0] + '-' + holidayString.split('-')[1]);
            dateNow.setDate(dateNow.getDate() + 1); // this is where we add the date
            return (dateNow.getMonth() +  1) + '-' + dateNow.getDate();
        }
        if(
            this.getAppointmentAvailability().holiday.some(x => x === (d.getMonth() +  1) + '-' + d.getDate()) || 
            this.getAppointmentAvailability().holiday.some(x => calculateNextDate(x) === (d.getMonth() +  1) + '-' + d.getDate()) || 
            (day == 0 || day == 6)
            ){
            return false;
        }
        return true;
    }

    setTime(pSelectedTime, pSelectedTimeDesc){
        this.vAppointmentData.appointment_time = pSelectedTime;
        this.vAppointmentData.appointment_description = pSelectedTimeDesc;
    }

    checkAvailableTime(pSelectedDate){
        this.vAppointmentData.appointment_time = '';
        this.vAppointmentData.appointment_description = '';
        this.vAppointmentData.appointment_date = pSelectedDate;
        this._nceService.loadAvailableTime(pSelectedDate, this.vAppointmentData.appointment_type);
    }

    isDisableSubmit(){
        if(this.vAppointmentData.appointment_date == null || this.vAppointmentData.appointment_time == '' || this.vAppointmentData.appointment_description == ''){
            return true;
        }
        return false;
    }

    close(){
        this._popupService.closePopup();
        this._nceService.vListTime = [];
    }

    changeAppointment(){
        this._popupService.openPopup( 'confirmation', {
            title: 'Notice',
            message: 'Book on',
            secondLineMessage: this.vAppointmentData.appointment_date.getDate() + '-' +(this.vAppointmentData.appointment_date.getMonth() + 1) + '-' + 
            this.vAppointmentData.appointment_date.getFullYear() + ' ' + this.vAppointmentData.appointment_description,
            buttons: {
                CANCEL: {
                    text: 'No',
                    function: () => {
                        this._popupService.closeConfirmationPopup();
                    }
                },
                OK: {
                    text: 'Yes',
                    function: () => {
                        this._nceAdminService.changeAppointment(this._nceService.vNCEID.nce_record_id, this.vAppointmentData.appointment_date, this.vAppointmentData.appointment_time).then(
                            (resolve) => {
                                this.openConfirmPopup(this.vAppointmentData.appointment_type.charAt(0).toUpperCase() + this.vAppointmentData.appointment_type.slice(1) + ' successfully Changed', true, false);
                            },
                            (reject) => {
                                this.openConfirmPopup('Appointment unable to be changed', false, true);
                            }
                        );
                    }
                }
            }}
        );
    }

    openConfirmPopup(pMessage, pIsChecked, pIsFalse){
        this._popupService.closeConfirmationPopup();
        this._popupService.openPopup( 'confirmation', {
            title: 'Notice',
            message: pMessage,
            isCheckedImage: pIsChecked,
            isErrorImage: pIsFalse,
            buttons: {
                CANCEL: {
                    text: 'Close',
                    function: () => {
                        this._nceService.loadAdminDetailNCE(this._nceService.vNCEID.nce_record_id);
                        this.close();
                    }
                },
            }}
        );
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/components/popup/change-appointment-popup.component.ts